<template>
  <div :class="{ 'top-nav-container': true, 'is-hidden': hideTopbar, 'my-card-page': isMyCardPage }">
    <nav id="top-nav" class="top-bar">
      <div class="top-bar-left">
        <router-link :to="{ name: 'home' }">
          <img src="@/assets/svgs/2024/kaernten-card_logo2024.svg" alt="Kärnten Card Logo">
        </router-link>
      </div>

      <div class="top-bar-right">
        <!--<div class="top-bar-lang-select">
          <button @click="switchLanguage('de')" :disabled="this.$i18n.locale == 'de'" :class="{active : this.$i18n.locale == 'de'}">DE</button>
          <button @click="switchLanguage('en')" :disabled="this.$i18n.locale == 'en'" :class="{active : this.$i18n.locale == 'en'}">EN</button>
        </div>-->
        <button type="button" class="btn-nav-link" @click="dispatchOffCanvasToggle">
          <img src="@/assets/svgs/2024/icons/burger.svg" alt="Menu">
        </button>
      </div>
    </nav>

    <section id="page-actions" :class="`route-${this.$route.name}`">
      <slot></slot>
    </section>
  </div>
</template>
<script>
/*import BackButton from '@/components/BackButton.vue'*/

export default {
  name: 'TopNavigation',
  components: {
    /*BackButton*/
  },
  computed: {
    selectedSeason() {
      if (this.isMyCardPage) {
        return 'sommer'
      }

      return this.$store.state.season
    },
    seasonIcon() {
      if (this.selectedSeason === 'sommer') {
        return ['fal', 'sun']
      } else {
        return ['fal', 'snowflake']
      }
    },
    hideIndicator() {
      switch (this.$route.name) {
        case 'news':
          return true
        case 'single-news':
          return true
        case 'bookmarks':
          return true
        case 'my-card':
          return true
        case 'my-card-register':
          return true
      }

      return false
    },
    hideTopbar() {
      switch (this.$route.name) {
        case 'single-news':
          return true
        case 'map':
          return true
        case 'single-destination':
          return true
        case 'single-salespoint':
          return true
      }
      return false
    },
    isMyCardPage() {
      return this.$route.name === 'my-card' || this.$route.name === 'my-card-register'
    }
  },
  data() {
    return {
      langs: ['de', 'en'] // 'it', 'sl'
    }
  },
  methods: {
    dispatchOffCanvasToggle() {
      this.$emit('openOffCanvas')
    },
    closeOffCanvas() {
      if (this.$parent.$refs.offCanvas !== undefined) {
        $(this.$parent.$refs.offCanvas).foundation('close')
      }

      if (this.$refs.langMenu) {
        $(this.$refs.langMenu).foundation('hideAll');
      }
    },
    navigateToPage(routerConfig) {
      this.closeOffCanvas();
      this.$router.push(routerConfig)
    },
    switchLanguage(lang = 'de') {
      this.$i18n.locale = lang;
      this.$store.dispatch('updateLanguage', lang);
      this.closeOffCanvas();
    },
    openIosInstallationHint() {
      this.$eBus.$emit('show-ios-installation-hint')
    }
  },
}
</script>
<style lang="scss" scoped>
.top-nav-container {
  position: relative;
  padding-bottom: 0.5rem;
  /*border-bottom: 1px solid $light-gray;*/
  box-shadow: 0px 1px 20px rgba($black, .15);
  z-index: 1;

  /*&.my-card-page {
    background-color: get-color(secondary);
    border-bottom: none;
    box-shadow: none;

    #top-nav {
      background-color: get-color(secondary);
    }
  }*/
}
#top-nav {
  position: relative;

  .top-bar-right {
    display: flex;
    align-items: center;

    .btn-nav-link {
      width: 32px;
      height: 26px;
      margin-left: 30px;
      cursor: pointer;
    }

    .top-bar-lang-select {
      display: flex;
      flex-direction: column;

      button {
        border: 1px solid $medium-gray;
        padding: 12px;

        &:disabled {
          background: $light-gray;
          border: 1px solid $medium-gray;
          font-weight: bold;
          color: $dark-gray;
        }

        &:not(:disabled) {
          cursor: pointer;
        }
      }
    }
  }

  &.top-bar {
    /*align-items: flex-start;*/
    padding: 0 rem-calc(15);
    padding-top: rem-calc(15);
    padding-bottom: 1rem;

    .top-bar-left {
      width: 50%;
      max-width: rem-calc(200);
      padding-right: 20px;

      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
